import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      { path: '', name: 'Home', component: () => import('@/views/Home.vue') },
      { path: 'shop', name: 'Shop', component: () => import('@/views/Shop.vue') },
      { path: 'about', name: 'About', component: () => import('@/views/About.vue') },
      { path: 'features', name: 'Features', component: () => import('@/views/Features.vue') },
      { path: 'contact', name: 'Contact', component: () => import('@/views/Contact.vue') },
      { path: 'privacy', name: 'Privacy', component: () => import('@/views/Privacy.vue') },
      { path: 'terms', name: 'Terms', component: () => import('@/views/Terms.vue') },
    ],
  },
  { path: '*', redirect: '/' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
